export default "__VITE_ASSET__DYs0ddkC__"